/** Shared ButtonComp props for investor portal actions. */

const base = {
  borderRadius: 10,
  minHeight: 44,
  fontWeight: 600,
  padding: "0.5rem 1.25rem",
};

const primaryFillClass = "bg-primary1 text-white border-0";

export const investorButtonProps = {
  primary: {
    BorderColor: "var(--color-primary)",
    btnClassName: `w-100 ${primaryFillClass} fw-semibold`,
    ButtonInlineStyle: {
      ...base,
      backgroundColor: "var(--color-primary)",
      color: "#fff",
      width: "100%",
    },
  },
  primaryInline: {
    BorderColor: "var(--color-primary)",
    btnClassName: `${primaryFillClass} fw-semibold`,
    ButtonInlineStyle: {
      ...base,
      backgroundColor: "var(--color-primary)",
      color: "#fff",
      whiteSpace: "nowrap",
    },
  },
  secondary: {
    BorderColor: "var(--color-secondary)",
    ButtonInlineStyle: {
      ...base,
      backgroundColor: "#fff",
      color: "var(--color-secondary)",
      width: "100%",
    },
  },
  secondaryInline: {
    BorderColor: "var(--color-secondary)",
    ButtonInlineStyle: {
      ...base,
      backgroundColor: "#fff",
      color: "var(--color-secondary)",
      whiteSpace: "nowrap",
    },
  },
  outline: {
    BorderColor: "#a1a0a0",
    ButtonInlineStyle: {
      ...base,
      backgroundColor: "#fff",
      color: "#525252",
      width: "100%",
    },
  },
  danger: {
    BorderColor: "#ff4343",
    ButtonInlineStyle: {
      ...base,
      backgroundColor: "#fff",
      color: "#ff4343",
      width: "100%",
    },
  },
  dangerFilled: {
    BorderColor: "#ff4343",
    btnClassName: "w-100 text-white border-0 fw-semibold",
    ButtonInlineStyle: {
      ...base,
      backgroundColor: "#ff4343",
      color: "#fff",
      width: "100%",
    },
  },
  success: {
    BorderColor: "#19bc31",
    btnClassName: "w-100 text-white border-0 fw-semibold",
    ButtonInlineStyle: {
      ...base,
      backgroundColor: "#19bc31",
      color: "#fff",
      width: "100%",
    },
  },
  warning: {
    BorderColor: "#ff9500",
    btnClassName: "w-100 text-white border-0 fw-semibold",
    ButtonInlineStyle: {
      ...base,
      backgroundColor: "#ff9500",
      color: "#fff",
      width: "100%",
    },
  },
};
